import React, { useState } from "react";
import { Autocomplete, TextField, Chip, Stack, FormHelperText, FormControl } from "@mui/material";

const ReusableMultiComponent = ({
  label,
  placeholder,
  options,
  selectedOptions,
  setSelectedOptions,
  disabledValue,
  optionLabel = "name",
  error,
  helperText,
  requireValue
}) => {
  const [inputValue, setInputValue] = useState("");

  return (
    <Stack spacing={1}>
      {/* Input Field */}
      <Autocomplete
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: 0,
          }
        }}
        freeSolo
        options={options.filter((option) =>
          !selectedOptions.some(selected => selected[optionLabel] === option[optionLabel])
        )} // Hide already selected values
        inputValue={inputValue}
        onInputChange={(event, newValue) => setInputValue(newValue)}
        getOptionLabel={(option) => option[optionLabel] || ""}
        onChange={(event, newValue) => {
          if (newValue && !selectedOptions.some(selected => selected[optionLabel] === newValue[optionLabel])) {
            setSelectedOptions([...selectedOptions, newValue]); // Add new selection
            setInputValue(""); // Clear input field after selection
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label={label} placeholder={placeholder} error={error}
            helperText={helperText} InputLabelProps={{
              sx: {
                lineHeight: 1,
                top:-4
              },
            }} required={requireValue} />
        )}
        disabled={disabledValue}
        className="mb-2"
      />
      {/* Chips Displayed Below */}
      <Stack direction="row" flexWrap="wrap" gap={1} >
        {selectedOptions?.map((option, index) => (
          <Chip
            key={option[optionLabel]}
            label={option[optionLabel]}
            onDelete={() => {
              setSelectedOptions(selectedOptions.filter(item => item[optionLabel] !== option[optionLabel]));
              setInputValue(""); // Clear input field after deletion
            }}
            className="gn-actionbtn"
            disabled={disabledValue}
            sx={{marginBottom:'17px'}}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default ReusableMultiComponent;
